import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="session-cards"
export default class extends Controller {
  static targets = ['passwordField', 'newPasswordField', "openEye", "closeEye", "newOpenEye",
    "newCloseEye", "submitButton"]
  static values = { loadingLabel: { type: String, default: "Logging in…" } }

  // The id of the stream target that means "we're leaving this page" — a
  // successful login replaces #redirect_target with a script that navigates.
  // Any other stream (a flash alert) means we're staying, so the button has to
  // come back.
  static REDIRECT_TARGET = "redirect_target"

  connect() {
    // A failed login only replaces #flash, so this element is never re-rendered
    // and connect() won't fire again — we have to watch the streams ourselves.
    document.addEventListener("turbo:before-stream-render", this.onStreamRender)
    // Restore the button if the page is shown again (e.g. Turbo back/forward
    // cache, or a full re-render) so it never stays stuck loading.
    this.resetSubmitButton()
  }

  disconnect() {
    document.removeEventListener("turbo:before-stream-render", this.onStreamRender)
  }

  // Show a loading state on the submit button when the form is submitted, so the
  // user gets feedback while the (Turbo) request is in flight and can't double-
  // submit. The button is an <input type=submit> (can't hold a spinner span), so
  // we swap its value to the loading label, disable it, and flag aria-busy; the
  // .is-submitting class drives the CSS spinner.
  submitLoading() {
    if (!this.hasSubmitButtonTarget) return
    const btn = this.submitButtonTarget
    if (btn.dataset.originalValue === undefined) btn.dataset.originalValue = btn.value
    btn.value = this.loadingLabelValue
    btn.disabled = true
    btn.classList.add("is-submitting")
    btn.setAttribute("aria-busy", "true")
  }

  // Fallback for responses that render no stream at all: a network failure, or a
  // 4xx/5xx. A successful stream response leaves the reset to onStreamRender,
  // which fires whether or not submit-end has already run.
  submitEnd(event) {
    if (!event.detail?.success) this.resetSubmitButton()
  }

  // Bound field, not a method, so add/removeEventListener see the same function.
  onStreamRender = (event) => {
    if (event.target?.getAttribute?.("target") === this.constructor.REDIRECT_TARGET) return
    this.resetSubmitButton()
  }

  resetSubmitButton() {
    if (!this.hasSubmitButtonTarget) return
    const btn = this.submitButtonTarget
    if (btn.dataset.originalValue !== undefined) btn.value = btn.dataset.originalValue
    btn.disabled = false
    btn.classList.remove("is-submitting")
    btn.removeAttribute("aria-busy")
  }

  togglePasswordVisibility() {
    let passwordInput = ''
    let eyeTarget = ''
    let closeEyeTarget = ''
    if (event.currentTarget.dataset.newPassword == 'true') {
      passwordInput = this.newPasswordFieldTarget
      eyeTarget = this.newOpenEyeTarget
      closeEyeTarget = this.newCloseEyeTarget
    } else {
      passwordInput = this.passwordFieldTarget
      eyeTarget = this.openEyeTarget
      closeEyeTarget = this.closeEyeTarget
    }

    if (passwordInput.type === "password") {
      passwordInput.type = "text";
      eyeTarget.classList.remove('d-none')
      closeEyeTarget.classList.add('d-none')
    } else {
      passwordInput.type = "password";
      eyeTarget.classList.add('d-none')
      closeEyeTarget.classList.remove('d-none')
    }
  }
}
